import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FreelanceHisDetailComponent } from './freelanceHisDetail.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [FreelanceHisDetailComponent],
  exports: [
    FreelanceHisDetailComponent
  ],
  providers: [
  ]
})
export class FreelanceHisDetailModule { }
